import { isReference } from '@bloomreach/spa-sdk'

import * as StringFormatter from '../../../global/formatters/string-formatter.js'

import { getLocalPath, isCms, isLocal } from '../config/configuration'

export const getLink = (link, id) => {
  let _url =
    link &&
    link.link &&
    link.link.length > 0 &&
    (link.link[0].links ? link.link[0].links.site.href : link.link[0].string)

  if (_url && _url.endsWith('?id') && id) {
    _url += `=${id}`
  }

  if (_url) {
    return {
      url: _url,
      text: link.text,
      icon: link.icon,
      target: link.target,
      ...link,
    }
  }

  return
}

export const getLinkFromRef = (link, page) => {
  if (link && link.link && link.link.length > 0 && isReference(link.link[0])) {
    link.link[0] = page.getContent(link.link[0])
  }

  return link
}

export const getLinkUrl = (link, title) => {
  let translatedUrl = link?.href || link?.url

  if (title && translatedUrl?.indexOf('/details') > 0) {
    const translateUrlSplit = translatedUrl.split('/details')

    translatedUrl = `${translateUrlSplit[0]}/${StringFormatter.urlSafe(
      title
    ).toLowerCase()}/details${translateUrlSplit[1]}`
  }

  const isSamePage = translatedUrl?.startsWith('#')
  const isFullyQualified = translatedUrl?.startsWith('http')
  const isAbsolute = translatedUrl?.startsWith('//')
  const isBinaries = translatedUrl?.includes('/binaries')
  const localPath = getLocalPath()

  if (isAbsolute) {
    translatedUrl = translatedUrl?.replace('//', '/')
  }

  translatedUrl = translatedUrl?.replace('%c3%b1', 'n')

  return (
    (isFullyQualified ||
    isAbsolute ||
    isSamePage ||
    isBinaries ||
    localPath === '/advisor'
      ? ''
      : localPath === '/investorspa'
        ? '/investor'
        : localPath) + (translatedUrl || '')
  )
}

// External URL is `l.Link[0].string`; Internal URL is `l.Link[0]._meta.mirror.path`
export const getLinkFromApi = (link) => {
  return {
    url:
      link?.Link && link?.Link.length > 0
        ? link?.Link[0].string ||
          `${isLocal() || isCms() ? '/cti-site' : ''}${'/binaries/'}${
            link.Link[0]._meta.mirror?.path
          }`
        : '',
    text: link?.text,
    icon: link?.icon,
    description: link?.description,
  }
}

export const getLinkListFromApi = (links = []) => {
  return links?.map((l) => getLinkFromApi(l))
}

export const isRoutedUrl = (url) => {
  return (
    url &&
    !url.startsWith('http') &&
    (url.indexOf('/practice-management') > -1 ||
      url.indexOf('/institutional') > -1 ||
      url.indexOf('/cti-site/cti-institutional') > -1)
  )
}

export const isPdfUrl = (docURL) => {
  if (docURL) {
    const _docURL = docURL.toLowerCase()

    return (
      _docURL.indexOf('.pdf') >= 0 ||
      _docURL.indexOf('rightprospectus.com') >= 0
    )
  }

  return false
}

export const getCurrentPath = () => {
  let siteName = getLocalPath()
  if (siteName === '/investorspa') {
    siteName = '/investor'
  }
  let pathname = window.location.pathname.replace(siteName, '')

  if (pathname.endsWith('/')) {
    pathname = pathname.substring(0, pathname.length - 1)
  }

  return pathname
}
